import type {Item,Snapshot} from './model'
import {pendingActions} from './waitingPolicy'
import {currentStop,unstickOwnerAction} from './unstickModel'
import {pendingDecision,terminal} from './recoveryView'

// Display projection only. The server's approval policy remains authoritative.
export function systemHeld(item:Item){
 const stop=currentStop(item)
 return !!stop&&stop.kind!=='business_decision'&&!unstickOwnerAction(item)
}
export function needsOwner(item:Item,data:Snapshot){return !terminal(item)&&!systemHeld(item)&&pendingActions(item,data).length>0}
export const customer=(item:Item)=>String(item.ticket?.organization_name??item.direction?.organization_name??'')
export function ownerQuestion(item:Item,data:Snapshot){return pendingDecision(item)?.question??(currentStop(item)?.reason||pendingActions(item,data).join(' · ')||item.summary||'הסוכנים מטפלים במשימה')}
export function searchItems(items:Item[],query:string){
 const normalize=(value:string)=>value.normalize('NFKC').toLocaleLowerCase().replace(/[״׳"']/g,'')
 const tokens=normalize(query).match(/(?:לקוח:|ריפו:)(?:"[^"]+"|\S+)|\S+/g)??[]
 return items.filter(item=>tokens.every(token=>{
  if(token==='פתוח')return !terminal(item)
  if(token.startsWith('לקוח:'))return normalize(customer(item)+' '+item.title).includes(token.slice(5))
  if(token.startsWith('ריפו:'))return normalize(item.repo).includes(token.slice(5))
  if(/^#\d+$/.test(token))return item.pr_urls.some(url=>url.endsWith('/'+token.slice(1)))
  return normalize([item.title,item.summary,item.repo,customer(item),...item.pr_urls].join(' ')).includes(token)
 })).sort((a,b)=>Number(terminal(a))-Number(terminal(b))||b.updated_at.localeCompare(a.updated_at))
}
